import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fetchBlogsRandom5 } from "../../../api/blogsAPI";
import { placeholderImage, isValidUrl } from "../../invalidImage";

const RelatedBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const { blogId } = useParams();

  useEffect(() => {
    const getBlogs = async () => {
      try {
        const blogData = await fetchBlogsRandom5();
        if (Array.isArray(blogData)) {
          setBlogs(blogData);
        }
      } catch (error) {
        console.error("Failed to fetch related blogs:", error);
      }
    };
    getBlogs();
  }, [blogId]);

  const filteredBlogs = blogs
    .filter((b) => b.id !== parseInt(blogId))
    .slice(0, 3);

  return (
    <section className="relative py-16 lg:py-20 bg-gradient-to-br from-slate-50 via-white to-brand-50 overflow-hidden">
      <div className="absolute top-10 right-10 w-72 h-72 bg-brand-100/40 rounded-full blur-3xl" />
      <div className="absolute bottom-10 left-10 w-72 h-72 bg-eco-100/40 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-10"
        >
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold tracking-wider uppercase bg-eco-50 text-eco-700 mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-eco-500" />
            You May Also Like
          </span>
          <h2 className="font-oswald text-3xl lg:text-4xl font-semibold text-slate-900">
            Artikel{" "}
            <span className="text-gradient">Terkait</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredBlogs.map((blog, idx) => (
            <motion.div
              key={blog.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
            >
              <Link
                to={`/blog/${blog.id}`}
                className="group flex flex-col h-full bg-white rounded-3xl overflow-hidden shadow-soft hover:shadow-medium card-hover border border-slate-100 no-underline hover:no-underline"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={
                      isValidUrl(blog.image) ? blog.image : placeholderImage
                    }
                    alt={blog.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="text-xs font-semibold tracking-wider uppercase text-brand-600 mb-2 font-overpass">
                    {new Date(blog.created_at).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })}
                  </div>
                  <h3 className="font-oswald text-base lg:text-lg font-semibold text-slate-900 leading-snug line-clamp-2 group-hover:text-brand-700 transition-colors mb-3">
                    {blog.title}
                  </h3>
                  <div className="mt-auto pt-3 border-t border-slate-100 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-600 group-hover:gap-2.5 transition-all">
                    Baca artikel
                    <span>→</span>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedBlogs;
